import { WHITEBOARD_ID } from '../../../../react/features/whiteboard/constants';
export function getMonitorIndexForWhiteboard(state) {
    // @ts-ignore
    const { participantIds } = state['wizyconf/large-video'];
    return participantIds.findIndex((id) => id === WHITEBOARD_ID);
}
export function isWhiteboardOnMainScreen(state) {
    // @ts-ignore
    const { participantIds } = state['wizyconf/large-video'];
    // @ts-ignore
    if (!APP.wildix.wizy) {
        return null;
    }
    return participantIds.includes(WHITEBOARD_ID);
}
export function isScreenSharingOnRightScreen(screenShareParticipantId) {
    // @ts-ignore
    const { participantIds } = APP.store.getState()['wizyconf/large-video'];
    // @ts-ignore
    const rightScreenIndex = APP.wildix.wizy ? APP.wildix.wizy.screenKeys.length - 1 : 0;
    return Boolean(rightScreenIndex
        && participantIds.findIndex((id) => id === screenShareParticipantId) === rightScreenIndex);
}
